/* ============================================================
   Custom Menu No-Click — Son of Son
   Items del menú con href="#categorias" o "#nocategoria" no
   navegan al hacer click. Solo abren su dropdown (hover-disclosure
   se encarga del resto). Útil para el item "Categorías" que solo
   debe mostrar sus hijos.
   ============================================================ */
(function () {
  'use strict';

  const NO_CLICK_HREFS = ['#categorias', '#colecciones', '#nocategoria', '#noclick'];

  function shouldBlock(href) {
    if (!href) return false;
    return NO_CLICK_HREFS.some(function (h) {
      return href === h || href.endsWith(h);
    });
  }

  /* Listener delegado en document — funciona aunque el menu se
     re-renderee. Capture phase para correr antes que cualquier handler
     del theme. */
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href]');
    if (!link) return;
    if (!shouldBlock(link.getAttribute('href'))) return;
    e.preventDefault();
    e.stopPropagation();
    /* En mobile también queremos que el toggle del dropdown se ejecute.
       El theme escucha clicks en el botón siguiente (chevron) o usa
       hover-disclosure para mostrar dropdown. Si hay un sibling button,
       lo "click-eamos" para abrir el dropdown */
    const sibling = link.parentElement && link.parentElement.querySelector('.disclosure__toggle, [data-toggle-disclosure], button');
    if (sibling && sibling !== link) {
      sibling.click();
    }
  }, true);
})();
